export default function PHP_linkinfo() {
  return (
    <div>
      <h1>PHP_linkinfo</h1>
    </div>
  );
}
